module.exports = __webpack_public_path__ + "cobranca_zaul.svg?54d397b4d428138cb989cfbb28550b2f";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/cobranca_zaul.svg
// module id = 1137
// module chunks = 0